import { useContext } from "react";
import { PlayerProgressContext } from "@/contexts/PlayerContext";

/**
 * Live playback position (seconds), updates up to 4x/sec while playing.
 * Split out from usePlayer() so components that only care about *what* is
 * playing (TrackRow, QuickPickCard, Playbar shell, ...) don't re-render on
 * every progress tick. Use this only where you actually render the number
 * (ProgressBar, KaraokeView).
 */
export function usePlayerProgress(): number {
  return useContext(PlayerProgressContext);
}
